import { useQuery } from '@tanstack/react-query';
import { getTotalOpenIssues } from '../services/AnalyticReportsService';
export default function useTotalOpenIssues(filters) {
    return useQuery(['totalOpenIssues', filters.values.dateRange], () => getTotalOpenIssues(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
